// extracted by mini-css-extract-plugin
module.exports = {"portal":"styles__portal__VOX0W","wrapper":"styles__wrapper__3BxCF","btn-close":"styles__btn-close__1Hz9u","btnClose":"styles__btn-close__1Hz9u"};